import React, { useState } from "react";
import SingleSMS from "./SingleSMS";
import BulkSMSPage from "./BulkSMSPage";
import MassSMS from "./MassSMS";
import SmsSubscriptionPage from "./SmsSubscriptionPage";

export default function SendSMSPage() {
  const [activeTab, setActiveTab] = useState("mass");

  return (
    <div className="page-container">
      <h3>SMS Center</h3>
      <p className="subtitle">Send individual or bulk SMS</p>

      {/* Tabs */}
      <div className="tabs">

         <button
          className={activeTab === "mass" ? "tab active" : "tab"}
          onClick={() => setActiveTab("mass")}
        >
          Send SMS
        </button>


        {/* <button
          className={activeTab === "single" ? "tab active" : "tab"}
          onClick={() => setActiveTab("single")}
        >
          Single SMS
        </button> */}

        <button
          className={activeTab === "bulk" ? "tab active" : "tab"}
          onClick={() => setActiveTab("bulk")}
        >
          Bulk SMS
        </button>

       

        <button
          className={activeTab === "subscription" ? "tab active" : "tab"}
          onClick={() => setActiveTab("subscription")}
        >
          SMS Subscription
        </button>
      </div>

      {/* Content */}
      <div className="tab-content">
        {activeTab === "mass" && <MassSMS />}
        {/* {activeTab === "single" && <SingleSMS />} */}
        {activeTab === "bulk" && <BulkSMSPage />}
        {activeTab === "subscription" && <SmsSubscriptionPage />}
      </div>
    </div>
  );
}